import {TimelineMax, TweenMax} from 'gsap';

$(document).on('preloader-finish', () => {
  if ($(document).find('.page').hasClass('home')) {
    if (innerWidth >= 768) {
      let currentSlideNum = 0;
      let countSlides = $('.home__slider .slide').length;
      let slideTime = 5;
      let timeOut;
      let killedTimeout = false;

      function mainSlider() {
        for (let i = 0; i < countSlides; i++) {
          $('.home__slider .slide').eq(i).attr('data-slide', i).data('slide', i);
          $('.home__slider__nav').append(`<div data-nav="${i}">${i < 9 && 0}${i + 1}</div>`)
        }

        $('.home__slider .slide').eq(0).addClass('is-active');
        $(document).find('.home__slider__nav div').eq(0).addClass('is-active');
      }

      function nextSlide(slide) {
        currentSlideNum = slide;
        let $currentSlide = $(document).find('.home__slider .slide.is-active');
        let $nextSlide = $(document).find(`.home__slider .slide[data-slide="${slide}"]`);

        let tl = new TimelineMax({
          onStart() {
            $('.home__slider__nav').addClass('not-active');
          },
          onComplete() {
            $currentSlide.removeClass('is-active');
            $nextSlide.removeClass('is-next').addClass('is-active');
            $(document).find(`.home__slider__nav div[data-nav="${slide}"]`).addClass('is-active');
            $('.home__slider__nav').removeClass('not-active')
            TweenMax.set([$currentSlide.find('.image'), $currentSlide.find('.textblock')], {clearProps: 'all'});

            timeOut = setTimeout(() => {
              nextSlide(currentSlideNum < countSlides - 1 ? currentSlideNum + 1 : 0);
            }, slideTime * 1000)
          }
        })
          .to($currentSlide.find('.image'), 0.35, {
            autoAlpha: 0,
            x: 50,
          })
          .to($currentSlide.find('.textblock'), 0.35, {
            autoAlpha: 0,
            x: -50,
          }, 0)
          .add($nextSlide.addClass('is-next'))
          .add($(document).find('.home__slider__nav div.is-active').removeClass('is-active'))
          .from($nextSlide, 0.35, {
            autoAlpha: 0,
            clearProps: 'all',
          })
          .from($nextSlide.find('.image'), 0.35, {
            autoAlpha: 0,
            x: 50,
            clearProps: 'all',
          })
          .from($nextSlide.find('.textblock'), 0.35, {
            autoAlpha: 0,
            x: -50,
            clearProps: 'all',
          }, 0.7)

        $(window).on('killAnimation', () => {
          tl.kill();
        });
      }

      setTimeout(() => {
        if (!killedTimeout) {
          nextSlide(1);
        }
      }, slideTime * 1000)

      $(document).on('click', ('.home__slider__nav div'), (e) => {
        $(window).trigger('killAnimation')
        killedTimeout = true;
        clearTimeout(timeOut);
        nextSlide($(e.currentTarget).data('nav'));
      });

      mainSlider();
    } else {
      $('.home__slider .slides').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
      });
    }
  }
});